// extracted by mini-css-extract-plugin
module.exports = {"default":"loading-indicator_default__3Vwd1","sk-circleBounceDelay":"loading-indicator_sk-circleBounceDelay__2d6nZ"};